import React from 'react';

export interface DownloadBarProps {
  selected: string;
  setSelectedFileType: any;
  original?: string;
}

export const AllowedFileDownloadTypes = ['original', '.jpg', '.png', '.pdf'];

export default function FileTypeSelector(props: DownloadBarProps) {
  return (
    <div className='filetype-selector'>
      {AllowedFileDownloadTypes.map((item) => {
        let className = 'switch';
        if (item === props.selected) {
          className += ' selected';
        }
        return (
          <div
            key={item}
            onClick={() => props.setSelectedFileType(item)}
            className={className}>
            {item.replace('.', '').toUpperCase()}{' '}
            {item === 'original' ? props.original : ''}
          </div>
        );
      })}
    </div>
  );
}
